define('view/template/template.list.page',['require','exports','module','uikit/uikit','blockit','fukit','moment','handlebars','fukit','fukit','fukit'],function(require, exports, module) {
  // prettier-ignore
  var UIKit                      = require('uikit/uikit'),
      BlocKit                    = require('blockit'),
      Formatter                  = require('fukit').Formatter,
      Moment                     = require('moment'),
      Handlebars                 = require('handlebars'),
      RouteHelper                = require('fukit').RouteHelper,
      PageHeaderView             = require('fukit').PageHeaderView,
      PageableSegmentedTableView = require('fukit').PageableSegmentedTableView;

  var TemplateListPage = BlocKit.ResolveOptionsView.extend({
     events: {
      'click .import-template-button': 'onImportTemplateClick',
      'mouseover .import-template-button': 'onImportTemplateMouseover',
      'mouseleave .import-template-button': 'onImportTemplateMouseleave',
    },
    onImportTemplateClick: function(event) {
      event.preventDefault();
      let baseUrl = window.location.origin + '/coi-react/template/import';
      window.location.replace(baseUrl);
    },
    onImportTemplateMouseover: function(event) {
      event.target.style.backgroundColor = '#e0e0e0';
    },
    onImportTemplateMouseleave: function(event) {
      event.target.style.backgroundColor = '#cccccc';
    },
    resolveOptions: {
      root: {
        type: BlocKit.FullWidthLayoutView,
        pageHeader: {
          header: {
            text: 'Form Manager',
          },
          actions: [
            {
              name: 'importTemplate',
              text: 'Import Template',
              className: 'import-template-button',
              attributes: {
                style: 'display: inline-block; padding: 10px 20px; background-color: #cccccc; color: #000000CC; border: none; text-decoration: none; cursor: pointer; border-radius: 4px; font-weight: bold;',
              },
              behaviors: {
                NavigateOnPressBehavior: {
                  behaviorClass: BlocKit.NavigateOnEventBehavior,
                  navigateOnEvent: 'importTemplate',
                },
              },
            },
          ],
        },

        contentColumn: {
          components: [
            {
              type: BlocKit.PageableTableView,
              collection: '@resources.templateCollection',
              columns: [
                {
                  text: 'Type',
                  behaviors: {
                    ResolveRouteBehavior: {
                      route: 'template:detail',
                      params: { primaryId: '@model.id' },
                      behaviorClass: BlocKit.ResolveRouteBehavior,
                    },
                  },
                  sortable: true,
                  sort: 'templateType.description',
                  childView: UIKit.ComponentsContainerView,
                  childViewOptions: {
                    components: [
                      {
                        type: UIKit.Text,
                        bindings: {
                          text: 'templateType.description',
                        },
                        tagName: 'a',
                      },
                      {
                        type: UIKit.Text,
                        attributes: { style: 'font-size: 0.8em; color: rgba(0, 0, 0, 0.5); margin-left: 1em;' },
                        behaviors: {
                          BindAndFormatOptionValuesBehavior: {
                            optionValues: {
                              visible: {
                                modelAttribute: 'lockCreateDate',
                                formatter: function(value) {
                                  return !!value;
                                },
                              },
                              text: {
                                formatter: Formatter.chain()
                                  .formatter(function(model) {
                                    return (
                                      'locked by ' +
                                      model.get('lockUserFirstName') +
                                      ' ' +
                                      model.get('lockUserLastName') +
                                      ' ' +
                                      'on ' +
                                      Moment(model.get('lockCreateDate')).format('L LT')
                                    );
                                  })
                                  .prepend('<i class="icon lock"></i>')
                                  .handlebarSafeString(),
                              },
                            },
                            behaviorClass: BlocKit.BindAndFormatOptionValuesBehavior,
                          },
                        },
                      },
                    ],
                  },
                },
                {
                  text: 'Date Published',
                  data: 'latestRevisionPublishedDate',
                  sortable: true,
                  formatter: Formatter.date('L LT'),
                },
              ],
              emptyText: 'No templates.',
            },
          ],
        },
      },
    },
  });

  module.exports = TemplateListPage;
});

